module.exports = __webpack_public_path__ + "img/gps-navigator-cuate@2x.848c2281.png";